import React from 'react'
import { tipoRepasseVenda, abaRepasseVenda} from '../../util/constantsUtil';

const CabecalhoTabelaRepasseVenda = (tipo, aba) => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">            
            {tipo === tipoRepasseVenda.empresa.nome &&
                <div className="col">Empresa</div>}
            
            {tipo === tipoRepasseVenda.vendedor.nome &&
                <div className="col">Vendedor</div>}

            {tipo === tipoRepasseVenda.imposto.nome &&
                <div className="col">Grupo</div>}

            <div className="col">Total Taxa Serviço</div>
            <div className="col">Qtd. Total Reservas</div>
            <div className="col">Total Comissão</div>
            <div className="col">Total Com. Agente</div>
            <div className="col">Total Imposto</div>
            <div className="col">Total Custo Cancelamento</div>           
            <div className="col">Total Faturado</div>
            {tipo === tipoRepasseVenda.empresa.nome ?             
                <div className="col">Líquido Empresa</div> : ''}
            <div className="col">Total Repasse</div>
            {aba === abaRepasseVenda.historicoRepasse && 
                <div className="col">Resp.</div>}
            
            <div className='col'>Ações</div>
        </div>
    </div>
);


export default CabecalhoTabelaRepasseVenda;